import { Component, OnInit, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as firebase from 'firebase';
import { AmbitService } from '../ambit.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-create-admin',
  templateUrl: './create-admin.component.html',
  styleUrls: ['./create-admin.component.css']
})
export class CreateAdminComponent implements OnInit {

  public submitted = false ;
  public loading = false ;
  public userForm: FormGroup;
  public userAccess:any = {
    drivers:'',
    passengers:'',
    trips:'',
    cities:'',
    stops:'',
    categories:'',
    vehicles:'',
    payments:'',
    payouts:'',
    paymentSettings:'',
    notifications:'',
    tickets:'',
    admins:'',
  }

  constructor(private formBuilder: FormBuilder,
    public service: AmbitService,
    public router: Router,
    public toaster: ToastrService,
    public zone: NgZone, ) { 
      if(this.service.adminUser.userAccess.admins =='None') {
        this.router.navigate(['/home']);
      }
    }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      userName: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
      ])],
      password: ['', [Validators.required, Validators.minLength(6)]],
      phoneNo: ['', Validators.required],
    });

  }


  get f() { return this.userForm.controls; }

  onSelectUserAccess(value, field, isChecked) {
    var self=this;
    if(isChecked) {
      self.userAccess[field] = value ;
    } else {
      self.userAccess[field] = '' ;
    }
    
  }

  onSubmitUserForm() {
    var self=this;
    var isAccessSelected = true;
    for(var key in self.userAccess) {
      if(!self.userAccess[key]) {
        isAccessSelected = false ;
      }
    }
    self.submitted = true; 
    if(self.userForm.valid && isAccessSelected) {
      self.submitted = false;
      self.loading = true;

      var createUser = firebase.functions().httpsCallable('createUser');
      createUser({
        name: self.userForm.get("userName").value,
        email: self.userForm.get("email").value,
        password: self.userForm.get("password").value,
      }).then((result) => {
        if (result.data.status == 200) {
            self.saveUserData(result.data.data.uid);
        } else {
          self.loading = false;
          alert(result.data.data.errorInfo.message);
          self.toaster.error(result.data.data.errorInfo.message, '', {timeOut:4000});
        }
      }).catch((error) => {
        self.loading = false;
        self.toaster.error( error.message, '', {timeOut:4000});
        //alert(error);
      });


    }
  }


  saveUserData( uid: any) {
    var self=this;

    var userFormData:any = {
      userName: self.userForm.get("userName").value,
      email: self.userForm.get("email").value,
      phoneNo: self.userForm.get("phoneNo").value,
      password: self.userForm.get("password").value,
      isAdmin: true,
      uid: uid,
      timeStamp: Number(new Date()),
      userAccess: self.userAccess
    }

    firebase.database().ref('Users/' + uid).update(userFormData).then((result) => {
      // alert("Staff User Added Successfully!")
      self.toaster.success( 'New Admin added successfully', '', {timeOut:4000});
      self.userForm.reset();
      self.loading = false;
      this.router.navigate(['/view-admins']);
    }).catch((err) => {
      self.toaster.error( err.message, '', {timeOut:4000});
      self.loading = false;
      //alert(err);
    });

  }


}
